/* ================================================================
   FORMA OVERRIDES JS
   1. Sizes always visible right of product name
   2. Pre-order ticker
   3. Password gate
   4. Color chips on product page
   ================================================================ */
(function () {
  'use strict';

  /* ── HELPERS ──────────────────────────────────────────────── */
  function getHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function getImageEl(card) {
    return card.querySelector('.card-gallery, [class*="gallery"], [class*="media-wrapper"], figure, .media')
      || card.querySelector('.product-card__content');
  }

  var knownColors = ['black','white','cream','ivory','navy','red','blue','green','pink','brown','grey','gray','beige','tan','camel','ecru','stone','sand','sage','rust','burgundy','wine','blush','lilac','lavender','mustard','olive','orange','yellow','purple','teal','coral','mint'];

  function getColorFromString(str) {
    if (!str) return null;
    str = str.toLowerCase();
    for (var i = 0; i < knownColors.length; i++) {
      if (str.indexOf(knownColors[i]) > -1) return knownColors[i];
    }
    return null;
  }

  function colorToHex(colorName) {
    var map = {
      'black':'#0c0c0c','white':'#ffffff','cream':'#f5f0e8','ivory':'#fffff0',
      'ecru':'#e8e0cc','stone':'#b2a898','sand':'#c8b89a','beige':'#d4c5a9',
      'tan':'#c19a6b','camel':'#c19a6b','navy':'#1a2744','red':'#922b1e',
      'blue':'#3a5a8a','green':'#3d5a3e','pink':'#e8b4b8','brown':'#6e4b3a',
      'grey':'#888480','gray':'#888480','sage':'#8a9e8a','rust':'#8e3a1e',
      'burgundy':'#6e1a2a','wine':'#6e1a2a','blush':'#e8b4b8','lilac':'#b8a8d4',
      'lavender':'#b8a8d4','mustard':'#c8a020','olive':'#6e7a3a','teal':'#2a7a7a',
      'coral':'#e87a5a','mint':'#8ad4b8'
    };
    return map[colorName] || '#888480';
  }

  /* ── INJECT SIZES ─────────────────────────────────────────── */
  function injectSizes(card, product) {
    if (!product.variants || product.variants.length === 0) return;

    // Gift cards
    if (product.product_type === 'Gift Cards' || (product.tags && product.tags.indexOf('gift-card') > -1)
        || product.handle.indexOf('gift-card') > -1 || product.title.toLowerCase().indexOf('gift card') > -1) {
      var prices = product.variants.map(function(v) { return v.price; });
      var min = Math.min.apply(null, prices);
      var max = Math.max.apply(null, prices);
      injectSizeStrip(card, [{ title: '$' + (min/100).toFixed(0) + ' – $' + (max/100).toFixed(0), available: true }]);
      return;
    }

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') return;

    var hasMultipleOptions = product.options && product.options.length > 1;
    var sizeOptionIndex = -1;
    if (hasMultipleOptions) {
      product.options.forEach(function(opt, i) {
        var name = opt.toLowerCase();
        if (name === 'size' || name === 'sizes') sizeOptionIndex = i;
      });
    }

    if (hasMultipleOptions && sizeOptionIndex > -1) {
      var sizeMap = {};
      product.variants.forEach(function(v) {
        var size = v.options[sizeOptionIndex];
        if (!sizeMap[size]) sizeMap[size] = false;
        if (v.available) sizeMap[size] = true;
      });
      injectSizeStrip(card, Object.keys(sizeMap).map(function(s) {
        return { title: s, available: sizeMap[s] };
      }));
    } else {
      injectSizeStrip(card, product.variants.map(function(v) {
        return { title: v.title, available: v.available };
      }));
    }
  }

  function injectSizeStrip(card, sizes) {
    var content = card.querySelector('.product-card__content');
    if (!content) return;
    var outerGroup = null;
    Array.from(content.children).forEach(function(child) {
      if (child.classList.contains('group-block')) outerGroup = child;
    });
    if (!outerGroup) return;
    if (outerGroup.querySelector('.forma-sizes')) return;

    var strip = document.createElement('div');
    strip.className = 'forma-sizes';
    sizes.forEach(function(v) {
      var span = document.createElement('span');
      span.className = 'forma-size-btn' + (v.available ? '' : ' forma-sold-out');
      span.textContent = v.title;
      strip.appendChild(span);
    });

    var row = document.createElement('div');
    row.className = 'forma-info-row';
    var leftCol = document.createElement('div');
    leftCol.style.cssText = 'flex:1;min-width:0;overflow:hidden';
    while (outerGroup.firstChild) leftCol.appendChild(outerGroup.firstChild);
    row.appendChild(leftCol);
    row.appendChild(strip);
    outerGroup.appendChild(row);
  }

  /* ── INJECT TICKER ─────────────────────────────────────────── */
  function injectTicker(card, product) {
    var tags = product.tags || [];
    if (tags.indexOf('pre-order') === -1 && tags.indexOf('preorder') === -1) return;
    var imageEl = getImageEl(card);
    if (!imageEl) return;
    if (imageEl.querySelector('.forma-preorder-ticker')) return;
    imageEl.style.position = 'relative';
    var ticker = document.createElement('div');
    ticker.className = 'forma-preorder-ticker';
    var track = document.createElement('div');
    track.className = 'forma-ticker-track';
    for (var i = 0; i < 24; i++) {
      var span = document.createElement('span');
      span.textContent = 'PRE-ORDER';
      track.appendChild(span);
    }
    ticker.appendChild(track);
    imageEl.appendChild(ticker);
  }

  /* ── PROCESS CARD ──────────────────────────────────────────── */
  function processCard(card) {
    if (card.dataset.formaEnhanced) return;
    card.dataset.formaEnhanced = '1';
    var handle = getHandle(card);
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) {
        if (!product) return;
        injectSizes(card, product);
        injectTicker(card, product);
      })
      .catch(function() {});
  }

  /* ── OBSERVE for infinite scroll ──────────────────────────── */
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'PRODUCT-CARD') processCard(n);
        n.querySelectorAll && n.querySelectorAll('product-card').forEach(processCard);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ── PASSWORD GATE ─────────────────────────────────────────── */
  function initPwGate() {
    var gate = document.getElementById('forma-pw-gate');
    if (!gate) return;
    if (sessionStorage.getItem('forma_pw_unlocked')) { gate.classList.add('hidden'); return; }
    gate.classList.remove('hidden');
    var input = document.getElementById('forma-pw-input');
    if (input) setTimeout(function() { input.focus(); }, 100);
  }

  window.formaSubmitPw = function() {
    var input = document.getElementById('forma-pw-input');
    var error = document.getElementById('forma-pw-error');
    if (!input) return;
    if (input.value.trim() === (window.formaPwCode || '')) {
      sessionStorage.setItem('forma_pw_unlocked', '1');
      var gate = document.getElementById('forma-pw-gate');
      if (gate) gate.classList.add('hidden');
      if (error) error.classList.remove('show');
    } else {
      if (error) error.classList.add('show');
      input.select();
    }
  };

  /* ── PRODUCT PAGE COLOR CHIPS ─────────────────────────────── */
  function initProductPageChips() {
    var dataEl = document.getElementById('forma-pdp-color-data');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch(e) { return; }

    if (!data || !data.variants || data.variants.length === 0) return;

    var chips = [{ url: data.url, color: getColorFromString(data.title), current: true, title: data.title }];
    data.variants.forEach(function(v) {
      chips.push({ url: v.url, color: getColorFromString(v.title), current: false, title: v.title });
    });

    if (chips.length < 2) return;

    var row = document.createElement('div');
    row.className = 'forma-pdp-color-chips';

    chips.forEach(function(chip) {
      var a = document.createElement('a');
      a.href = chip.url;
      a.className = 'forma-pdp-chip' + (chip.current ? ' forma-pdp-chip--current' : '');
      a.title = chip.title || '';
      var hex = colorToHex(chip.color || 'black');
      a.style.background = hex;
      var isLight = ['white','cream','ivory','ecru','stone','sand','beige'].indexOf(chip.color) > -1;
      if (isLight) a.style.border = '1px solid #c2c0bc';
      row.appendChild(a);
    });

    // Insert before the first variant picker or add to cart button
    var target = document.querySelector(
      'variant-picker, [class*="variant-picker"], ' +
      '.add-to-cart__button, [class*="add-to-cart"], ' +
      '.buy-buttons, [class*="buy-buttons"]'
    );
    if (target) {
      target.parentNode.insertBefore(row, target);
    } else {
      // Fallback: append to product info area
      var info = document.querySelector('[class*="product-information"], [class*="product-details"]');
      if (info) info.appendChild(row);
    }
  }

  /* ── INIT ──────────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('product-card').forEach(processCard);
    initPwGate();
    initProductPageChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
